module.exports = __webpack_public_path__ + "img/png_icon.59f8d56f.svg";